export const data = [
  {
    title: "Quick Links",
    links: [
      { label: "About Us", link: "#" },
      { label: "Enquiry Now", link: "#" },
      { label: "Help (FAQS)", link: "#" },
      { label: "Contact Us", link: "#" },
    ],
  },
  {
    title: "Other Resources",
    links: [
      { label: "Support", link: "#" },
      { label: "Privacy Policy", link: "#" },
      { label: "Terms of Service", link: "#" },
      { label: "Business Loans", link: "#" },
      { label: "Loan Services", link: "#" },
    ],
  },
  {
    title: "Contact Us",
    links: [
      { label: "Join Discord", link: "#" },
      { label: "9.00am - 6.00pm", link: "#" },
      { label: "huionecapital@gmail.com", link: "#" },
      { label: "+(60)17-415 0083", link: "#" },
    ],
  },
];

export const description = `We're a government-registered loan company that specializes in
provicing personal and business loans. Our SSM No. is
202001030556(13868760D). We're here to help you make your dream a
reality.`;
